import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { CopilotOutput } from 'libs/end-to-end/src/copilot';

export const PromotionCopilotCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'promotionCopilot',
  isDataQueuingAllowed: true,
  outputFileName: 'promotion_copilot_output.json',
  outputSchema: CopilotOutput,
  resolveFocusArea: () => 'Promotion',
  resolveFilters: () => null,
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  complexityParams: {
    aValue: 0.643,
    multiplier: 0.01495,
  },
  eventProperties: (request) => {
    if (request.customVizId !== 'promotionCopilot') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      Filters: [
        {
          columnHeaderValue: 'Location',
          values: request.inputs.dropdowns.location,
        },
        {
          columnHeaderValue: 'Job Title',
          values: request.inputs.dropdowns.job_title,
        },
        {
          columnHeaderValue: 'Department',
          values: request.inputs.dropdowns.department,
        },
      ],
      'Selected Dimensions': [],
      'Selected Metrics': [],
      'Selected Focus Areas': [],
    };
  },
  getUrlPath: () => 'copilot/promotion',
};
